module.exports = __webpack_public_path__ + "assets/img/free_23.e7cd3c69.png";